import { components, reducers } from 'linksoft';

const moduleName = 'gis-map';
import gisMap from './gis-map';
import reducer from './reducer';

components.add('gis-map', gisMap);
reducers.add(moduleName, reducer);

export default {
    name: moduleName,
    containers: [gisMap],
    reducer: reducer
};


// WEBPACK FOOTER //
// ./App/components/modules/gis-map/index.js